import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { AppConstants } from 'src/app/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-update-picture',
  templateUrl: './update-logo.component.html',
  styleUrls: ['./update-logo.component.css']
})
export class UpdateLogoComponent implements OnInit {
  @Input() set logoToChange(value: any) {
    this.picturePreview = value.logo;
  }

  logoPicture: File;
  picturePreview: any;
  logoExists: boolean;
  lang: any = localStorage.getItem("language")?localStorage.getItem("language"):'en';

  constructor(
    private apiService: ApiService,
    private router: Router,
    private spinner: NgxSpinnerService,
    public functionsService: FunctionsService,
    public translate: TranslateService) { }

  ngOnInit() 
   {
    this.logoExists = false;
    this.getOrganizationProfile();
   }

  handleLogoPictureUpload(files: FileList) {
    if(files.item(0)){
      document.getElementById("doc-err").innerText = "";
      if (files.item(0).size > 5000000) {
        document.getElementById("doc-err").innerHTML = this.translate.instant('profile.img_upload_size_err');
        this.translate.onLangChange.subscribe(() => {
            document.getElementById("doc-err").innerHTML = this.translate.instant('profile.img_upload_size_err');
        });
      }
      else if(AppConstants.imageFormats.includes(files.item(0).type)){
        this.logoPicture = files.item(0);
        const reader = new FileReader();
        reader.onload = e => this.picturePreview = reader.result;
        document.getElementById("fileLabel").innerHTML = this.logoPicture.name;
        reader.readAsDataURL(this.logoPicture);
      }
      else {
        document.getElementById("doc-err").innerText = this.translate.instant("error.image_format");
        this.translate.onLangChange.subscribe(() => {
          if(document.getElementById("doc-err").innerText){
            document.getElementById("doc-err").innerText = this.translate.instant("error.image_format");
          }
        });
      }
    }
  }

  saveLogo() {
    this.spinner.show();
    this.apiService.uploadLogoPicture(this.logoPicture)
    .subscribe(
      () => {
        this.spinner.hide();
        this.router.navigateByUrl('main/account-owner');
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    );
  }

  deleteLogo(){
    this.spinner.show();
    this.apiService.deleteLogo().subscribe(
      () => {
        this.spinner.hide();
        this.router.navigateByUrl('main/account-owner');
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    );
  }

  getOrganizationProfile(){
    this.apiService.getOrganizationProfile().subscribe(
        data => {
          if(data['logo']){
            this.logoExists = true;
          }
            this.picturePreview = data['logo'];
        },
        error => {
            this.functionsService.errorHandler(error["status"]);
        }
    );
}
}
